module.exports = __webpack_public_path__ + "img/payroll-icon1.0f97cfff.svg";